module.exports = __webpack_public_path__ + "img/star-wars-light-medium.da40b275.svg";